import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phone',
})
export class PhonePipe implements PipeTransform {
  transform(phone: string | undefined) {
    if (phone !== undefined) {
      const digits = phone.replace(/\D/g, '');
      return `${digits.slice(0, 3)}\u2011${digits.slice(3, 6)}\u2011${digits.slice(6)}`;
    } else {
      return phone;
    }
  }
}
